module.exports = __webpack_public_path__ + "img/image_007.f5b03219.jpeg";